import React, { useMemo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const SortableTaskRow = ({ task, children }) => {
	const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
		id: task.id || task.tempId
	});
	const style = useMemo(
		() => ({
			transform: CSS.Transform.toString(transform),
			transition,
			opacity: isDragging ? 0 : 1,
			background: isDragging ? '#f0f0f0' : '',
			cursor: isDragging ? 'grabbing' : 'pointer'
		}),
		[transform, transition, isDragging]
	);

	return (
		<tr ref={setNodeRef} style={style} {...attributes} {...listeners}>
			{children}
		</tr>
	);
};

export default SortableTaskRow;
